<template>
	<header
		:class="[
			'main-header',
			'd-flex',
			{ active: mobileMenu },
			{
				'justify-content-around':
					windowWidth >= mobileBreakpoint && !isTestResult,
			},
			{ 'gray-header': isTest || isTestResult },
		]"
	>
		<div
			:class="[
				'logo-header',
				'd-flex',
				'align-items-center',
				{ 'hide-logo-header': isTest },
				{ 'logo-test-rasult': isTestResult },
			]"
			v-if="windowWidth >= mobileBreakpoint"
		>
			<router-link to="/">
				<img src="images/mBank-logo.svg" alt="Logo mBank" />
			</router-link>
		</div>
		<app-sidebar-menu
			v-if="windowWidth >= mobileBreakpoint && !isTest && !isTestResult"
		/>
		<template v-if="!isTest && !isTestResult">
			<template v-if="windowWidth < mobileBreakpoint">
				<app-nav-icon />
				<img
					:key="2"
					src="images/off.png"
					@click="logOut()"
					class="btn-logout-mobile"
				/>
				<transition name="fade" mode="out-in">
					<span
						v-if="!mobileMenu"
						:key="1"
						class="page-title mr-auto"
						>{{ $route.meta.title }}</span
					>
				</transition>
				<transition name="slide-down">
					<mobile-menu v-show="mobileMenu" />
				</transition>
			</template>
			<template v-else>
				<div class="user-header">
					<span v-if="!currentUser.isCompany"
						>Witaj, {{ currentUser.firstName }}</span
					>
					<span v-else>{{ currentUser.companyName }}</span>
					<img
						src="images/off.png"
						@click="logOut()"
						class="btn-logout"
					/>
				</div>
			</template>
		</template>

		<template v-else-if="isTest && !isTestResult">
			<learning-progress-bar />
			<div @click="leaveQuiz()" class="close-quiz-button">
				<img src="images/learning/close.svg" alt />
			</div>
		</template>
	</header>
</template>

<script>
import AppNavIcon from '@/components/mobile/AppNavIcon';
import MobileMenu from '@/components/mobile/AppMobileMenu';
import AppSidebarMenu from '@/components/AppSidebarMenu';
import LearningProgressBar from '@/views/Learning/partial/LearningProgressBar';
import { mapGetters } from 'vuex';

export default {
	components: {
		AppNavIcon,
		MobileMenu,
		AppSidebarMenu,
		LearningProgressBar,
		// MobileSlideIndicator,
	},
	methods: {
		logOut() {
			this.$store.dispatch('toggleMobileMenu', false);
			this.$store.dispatch('logOut');
		},
		leaveQuiz() {
			this.$store.commit('setChangePath', false);
			this.$router.push('/Dashboard');
		},
	},
	computed: {
		// userData() {
		// 	return this.$store.getters.getUser
		// 		? this.$store.getters.getUser
		// 		: false;
		// },
		currentUser() {
			return this.$store.getters.getCurrentUser
				? this.$store.getters.getCurrentUser
				: false;
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		mobileMenu() {
			return this.$store.getters.getShowMobileMenu;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing' }),
		isTest() {
			return this.$route.name === 'eLearningTest';
		},
		isTestResult() {
			return this.$route.name === 'eLearningTestResult';
		},
	},
};
</script>
